import api from './client';

export interface SmartloggerCurrentRow {
  deviceId: number;
  serialNumber: string | null;
  deviceName: string;
  brand: string | null;
  model: string | null;
  softwareVersion: string | null;
  status: number | null;
  webBaseUrl: string | null;
  lastSeenAt: string | null;
  readingId: number | null;
  logtime: string | null;
  id: number;
  quantity: string;
  dataType: string | null;
  units: string | null;
  webPageTag: string | null;
  notes: string | null;
  valueNumeric: number | null;
  valueText: string | null;
}

export interface SmartloggerCurrentResponse {
  ok: boolean;
  plantName: string;
  rows: SmartloggerCurrentRow[];
}

export interface SmartloggerHistoryRow {
  timestamp: string;
  valueNumeric: number;
}

export interface SmartloggerHistoryResponse {
  ok: boolean;
  date: string;
  rows: SmartloggerHistoryRow[];
}

export async function fetchSmartloggerCurrent(uuidId: string): Promise<SmartloggerCurrentResponse> {
  const response = await api.get<SmartloggerCurrentResponse>(`/powerplants/${uuidId}/smartlogger/current`);
  return response.data;
}

export async function fetchSmartloggerHistory(
  uuidId: string,
  params: { registerMapId: number; date: string },
): Promise<SmartloggerHistoryResponse> {
  const response = await api.get<SmartloggerHistoryResponse>(`/powerplants/${uuidId}/smartlogger/history`, { params });
  return response.data;
}
